export default __webpack_public_path__ + "static/media/acceso-camara-mac-5.f23cc46d.svg";